import { Component } from "react";

import type { PropsWithChildren } from "react";

export interface TBodyProps {
	className?: string;
}

class TBody extends Component<PropsWithChildren<TBodyProps>> {
	render() {
		return <tbody className={this.props.className || ""}>{this.props.children}</tbody>;
	}
}

export default TBody;
